import { mapRegionForLocale } from './getEffectiveLocale.ts';
import logger from './logger.ts';

let hasWarnedAboutObrDeprecation = false;

/**
 * Resolves onboarding region from query params.
 * Priority: region → r → fallbackParam (default "obr").
 * Normalizes via mapRegionForLocale (e.g. uk → GB).
 */
export function resolveQueryRegion(query: URLSearchParams, fallbackParam = 'obr'): string | null {
  const region = query.get('region')?.trim();
  const r = query.get('r')?.trim();
  const fallback = query.get(fallbackParam)?.trim();

  const raw = region || r || fallback;
  if (!raw) return null;

  if (!region && !r && fallback && !hasWarnedAboutObrDeprecation) {
    hasWarnedAboutObrDeprecation = true;
    logger.warn(`"${fallbackParam}" query param is deprecated; use "region" instead.`);
  }

  return mapRegionForLocale(raw) ?? null;
}
